export default __webpack_public_path__ + "static/media/Energy.a41385a4.jpg";